/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable import/no-extraneous-dependencies */
import { Tag } from '@components';
import { useNavigateWithOfflineMode, useScreenSize } from '@hooks';
import { courseApi } from '@store';
import { Flex, theme, Typography } from '@styles';
import { shape } from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useIndexedDB } from 'react-indexed-db-hook';
import { useDownloadingState } from 'src/hooks/useDownloadingState';
import { precacheModule } from 'src/hooks/useOfflineModulesRoutesPrecaching';

import { useOfflineImage } from '../../../../hooks/useOfflineImage';
import { useOnlineStatusDetector } from '../../../../hooks/useOnlineStatusDetector';
import { tagsProps } from '../../OfflineContentPage.layoutProps';
import DownloadingStateBadge from '../DownloadingStateBadge/DownloadingStateBadge';

const OfflineModuleCard = ({ dataModule }) => {
  const { i18n } = useTranslation();
  const { isTabletLG, isTabletSM } = useScreenSize();
  const { navigate } = useNavigateWithOfflineMode();
  const moduleImage = useOfflineImage(dataModule?.image) || dataModule?.image;
  const { isOnline } = useOnlineStatusDetector();

  const { add } = useIndexedDB('modules');

  const [isInProgress, setIsInProgress] = useState(false);
  const { module, refetch } = courseApi.useGetOfflineCourseModuleByIdQuery(
    {
      id: dataModule?.id,
    },
    {
      refetchOnMountOrArgChange: isOnline,
      selectFromResult: ({ data }) => ({
        module: data?.data,
      }),
      skip: !isOnline,
    }
  );

  useEffect(() => {
    const timerId = setTimeout(() => {
      if (module) refetch();
    }, 200);
    return () => clearTimeout(timerId);
  }, [i18n.language]);

  const handleClickModule = () => {
    const moduleId = dataModule?.id || module?.id;
    const courseId = module?.course_id || dataModule?.course_id;

    navigate(`/courses/${courseId}/${moduleId}`, {});
  };

  const totalSize = useMemo(
    () => ((dataModule?.size_in_bytes || 0) / (1024 * 1024)).toFixed(2),
    [dataModule?.size_in_bytes]
  );

  const {
    deleteModule,
    downloadedSize,
    isActualInfo,
    isDownloaded,
    startDownloading,
  } = useDownloadingState(module, totalSize);

  const downloadModule = async () => {
    setIsInProgress(true);

    await startDownloading();
    await add({ ...dataModule, ...module });
    await precacheModule(module.course_id, module.id);
    setIsInProgress(false);
  };

  const onStopDownloading = () => {
    setIsInProgress(false);
  };

  const memoTags = useMemo(
    () =>
      tagsProps
        .filter((el) => !!dataModule[el.key])
        .map((tag) => (
          <Flex display="block">
            <Tag
              content={
                tag.key === 'isTest'
                  ? i18n.t(tag.translationName)
                  : `${dataModule[tag.key]} ${i18n.t(tag.translationName)}`
              }
              variant={tag.keyTag}
            />
          </Flex>
        )),
    [dataModule, tagsProps]
  );

  return (
    <Flex
      backdropFilter="blur(17px)"
      bg={theme.colors.white[10]}
      borderColor={theme.colors.whiteLine[100]}
      borderStyle="solid"
      borderWidth={1}
      flexDirection="column"
      justifyContent="center"
      mb={3}
      minHeight={160}
    >
      <Flex
        flexDirection={isTabletSM ? 'column' : 'row'}
        position="relative"
        px={isTabletSM ? 16 : 24}
        py={24}
      >
        {isTabletSM && isOnline && isActualInfo && (
          <DownloadingStateBadge
            downloadedSizeMB={downloadedSize}
            isDownloaded={isDownloaded}
            isInProgress={isInProgress}
            onDelete={deleteModule}
            onDownload={downloadModule}
            onStop={onStopDownloading}
            setIsInProgress={setIsInProgress}
            sizeMB={totalSize}
          />
        )}
        <Flex
          flexDirection={isTabletSM ? 'column' : 'row'}
          gap={24}
          onClick={handleClickModule}
        >
          <Flex
            alt="avatar"
            {...(isTabletSM && !Number.isNaN(totalSize) && totalSize !== 0
              ? {
                  background: `linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%), url("${moduleImage}") lightgray 0px -24.132px / 100% 240.427% no-repeat`,
                  backgroundSize: 'cover',
                  filter: isOnline && 'blur(2px)',
                }
              : {
                  backgroundImage: moduleImage,
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                })}
            height={isTabletSM ? '216px' : isTabletLG ? '100%' : 'auto'}
            minWidth="270px"
            width={isTabletSM ? '100%' : '270px'}
          />
          <Flex
            flexDirection="column"
            gap={isTabletSM ? 24 : 16}
            justifyContent="space-between"
          >
            <Flex flexDirection="column">
              <Typography
                color={theme.colors.white[100]}
                variant="MS-bold-s20-lh21"
              >
                {dataModule?.title}
              </Typography>
              <Typography
                color={theme.colors.white[100]}
                mt="8px"
                opacity="60%"
                variant="MS-regular-s14-lh22"
              >
                {dataModule?.description}
              </Typography>
            </Flex>
            <Flex flexWrap="wrap" gap={8}>
              {memoTags.map((el) => el)}
            </Flex>
          </Flex>
        </Flex>
        {module && !isTabletSM && isOnline && isActualInfo && (
          <DownloadingStateBadge
            downloadedSizeMB={downloadedSize}
            isDownloaded={isDownloaded}
            isInProgress={isInProgress}
            onDelete={deleteModule}
            onDownload={downloadModule}
            onStop={onStopDownloading}
            setIsInProgress={setIsInProgress}
            sizeMB={totalSize}
          />
        )}
      </Flex>
    </Flex>
  );
};

OfflineModuleCard.propTypes = {
  dataModule: shape.isRequired,
};

export default OfflineModuleCard;
